export default "__VITE_ASSET__Dduh4OGZ__"